import { render } from "./CustomSelectOneHorseBreed.vue?vue&type=template&id=c3e65f4a"
import script from "./CustomSelectOneHorseBreed.vue?vue&type=script&lang=js"
export * from "./CustomSelectOneHorseBreed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__